import { useEffect } from 'react';
import { Client } from '../../../prismic1';
import Prismic from 'prismic-javascript';
import { useLayout } from '../../../utils/layout-context';
import { getLanguage } from '../../../lib/getLanguage';
import Head from '../../../components/Head';
import { getBlogsPaths } from '../../../services/pagination/getBlogsPaths';
import AllBlogs from '../../../components/AllBlogs';
import errorService from '../../../services/error/error-service';

const BlogPage = (props) => {
  const { all_blogs, all_blog_categories, params, blogPostData } = props;
  const { setHeaderColor } = useLayout();

  const canonical =
    params.idx === 1 || params.idx === '1'
      ? '/blog'
      : `/blog/page/${params.idx}`;
  useEffect(() => {
    setHeaderColor(true);
  }, []);

  return (
    <>
      <Head data={blogPostData.data} canonical={canonical} />
      <AllBlogs
        allBlogs={all_blogs}
        allBlogCategories={all_blog_categories}
        params={params}
        blogPostData={blogPostData}
      />
    </>
  );
};

export const queryParams = {
  fetchLinks: [],
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  //if the id parameter is not a whole number, return the 404 error page
  if (!params.idx || isNaN(params.idx) || params.idx % 1 !== 0) {
    return errorService.notFoundResponse;
  }

  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();
  const all_blogs = await client.query(
    [
      Prismic.Predicates.at('document.type', 'blog_post'),
      Prismic.Predicates.has('my.blog_post.date'),
    ],
    {
      lang: language,
      fetchLinks: ['project_category.title', 'blog_topic.topic_name'],
      page: params.idx,
      pageSize: 26,
      orderings: '[my.blog_post.date desc]',
    }
  );
  const all_blog_categories = await client.query(
    Prismic.Predicates.at('document.type', 'blog_topic'),
    {
      lang: language,
    }
  );
  const blogPostData = await client.getSingle('learn', { lang: language });
  return {
    props: {
      params,
      all_blogs,
      all_blog_categories,
      blogPostData,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();
  const paths = await getBlogsPaths();
  return {
    paths,
    fallback: 'blocking',
  };
}
export default BlogPage;
